import React from 'react';
import './Companies.css'

const Empresa = (props) => {

    const { empresa, onClick } = props;

    return(
        <div className="companies-option-container">
            <button className="companies-option-button" onClick={() => {onClick(empresa.id)}}>{empresa.razonSocial}</button>
        </div>
    );
}

const CompaniesView = (props) => {

    const { empresas } = props.data;
    const { onClick } = props;

    return(
        <div className="companies-main-container">
            <h2 className="companies-title">Seleccione la empresa:</h2>
            <div className="companies-data-container">
                {
                    empresas.map((empresa, index) => {
                        return(
                            <Empresa key={index} empresa={empresa} onClick={onClick} />
                        );
                    })
                }
            </div>
        </div>
    );
}

export default CompaniesView;